export const ATTACHMENT_CONST = {
    tNamespace: "dialogs",
    tPath: {
        notLoaded: "attachments.not-loaded"
    },
    truncateProps: {
        length: 14,
        omission: "..."
    }
}

export const UPLOAD_FILE_ERROR = "UPLOAD_FILE_ERROR"
